import React from 'react'

const BAR_COUNT = 12

const BarChartClassroomSkeleton = () => {
    return (
        <div style={{ width: '100%', paddingTop: 30, position: 'relative' }}>
            <div
                className="w-full h-full flex flex-col items-center justify-center"
                style={{
                    height: 130,
                    position: 'relative',
                    // background: '#f8f8fb',
                }}
            >
                {/* Vertical bars */}
                <div
                    className="classroom-barchart-grid"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 3,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'flex-end',
                    }}
                >
                    {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                        <div
                            key={idx}
                            style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                padding: '0 4px',
                            }}
                        >
                            <div
                                className="animate-pulse"
                                style={{
                                    width: '85%',
                                    height: `${60 + ([20, 40, 60, 80][idx % 4] / 100) * 120}px`,
                                    borderRadius: 6,
                                    background: '#7ec5c6',
                                    marginBottom: 8,
                                    opacity: 0.5,
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
            {/* Labels */}
            <div
                className="classroom-barchart-grid"
                style={{
                    marginTop: 9,
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                }}
            >
                {Array.from({ length: BAR_COUNT }).map((_, idx) => (
                    <div
                        key={idx}
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <div
                            className="animate-pulse"
                            style={{
                                width: 24,
                                height: 24,
                                borderRadius: 16,
                                background: '#7ec5c6',
                                marginBottom: 6,
                                opacity: 0.5,
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BarChartClassroomSkeleton
